import { Tooltip } from '@mui/material';
import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { CuriosityTranslation, CuriosityValue, CuriosityValueProps } from '@procureai/curiosity-ui-mui';
import { Restricted, RestrictionCheck } from '@procureai/permissions-ui';
import { Union } from 'ts-toolbelt';

import { DataGridLink } from '../../components/DataGridLink';
import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';

export type CuriosityValueValue = Union.Nullable<string>;

interface CuriosityValueCellProps<R extends GridValidRowModel = any> {
  value: CuriosityValueValue;
  row: R;
  ns: CuriosityValueProps['ns'];
  to?: string;
  needs?: RestrictionCheck;
}

export const CuriosityLinkCell = <R extends GridValidRowModel = any>({
  value: i18nKey,
  ns,
  to,
  needs,
}: CuriosityValueCellProps<R>) => {
  if (!i18nKey) {
    return <>{NULLISH_CELL_VALUE}</>;
  }
  return (
    <CuriosityValue ns={ns} i18nKey={i18nKey} valueGetter={(ct) => ct}>
      {(value) => {
        const label = (value as CuriosityTranslation).value;
        if (to) {
          return (
            <Restricted needs={needs} fallback={label}>
              <Tooltip title={label}>
                <span>
                  <DataGridLink to={to}>{label}</DataGridLink>
                </span>
              </Tooltip>
            </Restricted>
          );
        }
        return (
          <Tooltip title={label}>
            <span>{label}</span>
          </Tooltip>
        );
      }}
    </CuriosityValue>
  );
};
